// extracted by mini-css-extract-plugin
export default {"antCollapse":"FreeTextResponses_antCollapse__EdutR"};